export const DEV_SERVERS = [
  {
    value: 'https://api-dev.oyindonesia.com',
    label: 'Dev A',
  },
  {
    value: 'https://api-dev2.oyindonesia.com',
    label: 'Dev B',
  },
  {
    value: 'https://api-dev3.oyindonesia.com',
    label: 'Dev C',
  },
  {
    value: 'https://api-dev4.oyindonesia.com',
    label: 'Dev D',
  },
  {
    value: 'https://api-dev5.oyindonesia.com',
    label: 'Dev E',
  },
  {
    value: 'https://api-dev6.oyindonesia.com',
    label: 'Dev F',
  },
  {
    value: 'https://api-dev7.oyindonesia.com',
    label: 'Dev G',
  },
  {
    value: 'https://api-dev-tmp.oyindonesia.com',
    label: 'Dev EKS',
  },
];
